import { useContext } from "react";

import { ZoneContext } from "../../contexts/user/ZoneContext";

const useZone = () => {
  const context = useContext(ZoneContext);
  return context;
};

export default useZone;
